<template>
  <div>
    <v-dialog v-model="showDialog" max-width="550">
      <widget
        v-if="selectedWidget"
        style="overflow: hidden"
        :value="selectedWidget"
        :tags="tags"
        :hide-buttons="hideButtons"
        global-widget
        @update="updateGlobalValues"
        @close="close"
        @input="(val) => updateWidget(val)"
        @open-color-form="(w) => $emit('open-color-form', w)"
        @open-image-map-editor="(w) => edit(w)"
        @select-widget="(w) => edit(w)"
      />
    </v-dialog>

    <v-btn
      v-for="(widget, i) in widgets"
      :key="i"
      icon
      @click="showWidget(widget)"
      class="float-right ml-1"
    >
      <v-icon>
        {{ getIconForWidgetType(widget.widgetType) }}
      </v-icon>
    </v-btn>

    <div v-if="displayTimeRange" class="float-right ml-1">
      <v-chip>
        {{
          $t("module.masterTimePicker.range") +
          ": " +
          (globalValues?.globalTimeRange?.start ?? "N/A")
        }}
        {{ " -> " + (globalValues?.globalTimeRange?.end ?? "N/A") }}</v-chip
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Widget from "./Widget.vue";
import widgetMixin from "@/_helpers/widgetMixin";
import CsharpEnum from "@/_helpers/CsharpEnum";

export default {
  name: "IconWidget",

  mixins: [widgetMixin],
  components: { Widget },

  props: {
    tags: {
      type: Array,
      default: () => [],
    },

    hideButtons: {
      type: Boolean,
      default: false,
    },

    value: {
      default: () => [],
    },
  },

  data() {
    return {
      showDialog: false,
      selected: undefined,
    };
  },

  computed: {
    ...mapState("templateDashboard", ["globalValues"]),

    widgets: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },

    selectedWidget() {
      return this.selected;
    },

    displayTimeRange() {
      return (
        this.widgets.find(
          (x) => x.widgetType == CsharpEnum.ModuleType.MASTERTIMEPICKER
        ) != undefined
      );
    },
  },

  methods: {
    ...mapActions("templateDashboard", ["updateGlobalWidget"]),

    async setup() {},

    showWidget(widget) {
      this.selected = widget;
      this.showDialog = true;
    },

    edit(widget) {
      this.showDialog = false;

      // Image map enabler
      if (this.isType(this.widgetTypes.IMAGEMAP, widget.widgetType)) {
        this.$emit("open-image-map-editor", widget);
      } else {
        this.$emit("select-widget", widget);
      }
    },

    updateWidget(value) {
      this.widgets[this.selectedWidget.i] = value;
    },

    updateGlobalValues() {
      this.updateGlobalWidget(this.widgets[this.selectedWidget.i]);
    },

    close() {
      this.showDialog = false;
    },
  },

  async created() {
    await this.setup();
  },
};
</script>
